import { getLabelMessage } from '@gef-ui/localization/messages';
import CircleExclamation from '@gef-ui/material-icons/CircleExclamation';
import useIsTabletAndUp from '@gef-ui/material/hooks/useIsTabletAndUp';
import { useVersionInfoLazy } from '@gef-ui/version-info-core';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { errorPropType } from '../../constants';
import { useDefaultComponentValue } from '../../utils';
import { CloseButton, HideButton, InlineActionButtons, RefreshButton, ReportButton } from '../ActionButtons';
import ErrorAlert from '../ErrorAlert';
import ErrorInfo from '../ErrorInfo';
import ErrorMeta from '../ErrorMeta';
const ExclamationCircleIcon = styled(CircleExclamation)(({ theme })=>({
        color: theme.palette.error.main,
        marginRight: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
            margin: theme.spacing(0, 0, 1)
        }
    }));
const COMPONENT_NAME = 'MuiCollapsibleError';
const CollapsibleErrorView = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { error, onRefresh, onClose, withSendOption, versionInfoConfig, isSent, isError, isSending, onSendError, onHide, ...other } = props;
    const { shortDescription, longDescription, heading, traceId, timestamp, screen } = error;
    const [isAlertVisible, setIsAlertVisible] = useState(true);
    const handleAlertClose = ()=>setIsAlertVisible(false);
    const { fe, be } = useVersionInfoLazy(versionInfoConfig);
    const isTabletAndUp = useIsTabletAndUp();
    const contentMarginLeft = isTabletAndUp ? 5 : 0;
    const actionButtons = /*#__PURE__*/ React.createElement(InlineActionButtons, null, /*#__PURE__*/ React.createElement(ReportButton, {
        withSendOption: withSendOption,
        onSend: ()=>onSendError(fe, be, error, timestamp),
        isSent: isSent,
        fe: fe,
        be: be,
        error: error,
        timestamp: timestamp,
        isSending: isSending
    }), onRefresh && /*#__PURE__*/ React.createElement(RefreshButton, {
        onClick: onRefresh
    }), onClose && /*#__PURE__*/ React.createElement(CloseButton, {
        onClick: onClose
    }), onHide && /*#__PURE__*/ React.createElement(HideButton, {
        onClick: onHide
    }));
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        ...other
    }, /*#__PURE__*/ React.createElement(Grid, {
        size: {
            xs: 12,
            md: 'grow'
        },
        sx: {
            alignItems: 'center',
            display: 'flex'
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: isTabletAndUp ? 'row' : 'column',
        sx: {
            alignItems: isTabletAndUp ? 'center' : 'flex-start'
        }
    }, /*#__PURE__*/ React.createElement(ExclamationCircleIcon, null), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5"
    }, `${getLabelMessage('common:error').toUpperCase()}: ${heading}`))), isTabletAndUp && actionButtons, /*#__PURE__*/ React.createElement(Grid, {
        size: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, !isTabletAndUp && actionButtons), /*#__PURE__*/ React.createElement(ErrorInfo, {
        isDesktop: isTabletAndUp,
        collapsible: true,
        shortDescription: shortDescription,
        longDescription: longDescription,
        infoSx: {
            ml: contentMarginLeft
        }
    }), isSent && isAlertVisible && /*#__PURE__*/ React.createElement(ErrorAlert, {
        isError: isError,
        error: error,
        fe: fe,
        be: be,
        timestamp: timestamp,
        sx: {
            ml: contentMarginLeft,
            mb: 3
        },
        onClose: handleAlertClose
    }), /*#__PURE__*/ React.createElement(ErrorMeta, {
        screen: screen,
        traceId: traceId,
        fe: fe,
        be: be,
        timestamp: timestamp,
        sx: {
            ml: contentMarginLeft
        }
    })));
};
CollapsibleErrorView.displayName = 'CollapsibleError';
CollapsibleErrorView.propTypes = {
    error: errorPropType.isRequired,
    isError: PropTypes.bool,
    isSending: PropTypes.bool,
    isSent: PropTypes.bool,
    onClose: PropTypes.func,
    onHide: PropTypes.func,
    onRefresh: PropTypes.func,
    onSendError: PropTypes.func,
    versionInfoConfig: PropTypes.object,
    withSendOption: PropTypes.bool
};
export default CollapsibleErrorView;
